import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getDashboardActions } from "../../../actions/dashboardActionsPP";
import NavBar from "./NavBar";
import * as DropdownTypes from "./DropdownTypes";
import DropdownItem from "./DropdownItem";
import { RouteMap } from "./routeMap";
import _ from "lodash";
import { switchRole } from "../../../actions/loginActions";
import { injectIntl } from "react-intl";
import messages from "components/messagesDescription";
import { isMobileBrowser } from "../../../utils";

const isEnabled = (menuItemId, profileMenu) =>
  !!(profileMenu && profileMenu.children.find(c => !_.isEmpty(c.name) && c.id === menuItemId));

const getCartPath = (menuItems, checkoutType) => {
  const isCheckoutEnabled = menuItems.find(
    item => item.children && item.children.find(child => child.id === checkoutType)
  );

  return isCheckoutEnabled && RouteMap[checkoutType];
};

const NEWSHOP_MENU_ID = "CXAShopMain_CXAShop";

const getNewShopUrl = menuItems => {
  const menuNewShop = menuItems.find(m => m.id === NEWSHOP_MENU_ID);
  return menuNewShop && menuNewShop.externalUrl;
};

const getDisplayedName = user => {
  if (user.employee) {
    return user.employee.fullName;
  }

  return null;
};

function NavMenuProfile(props) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const profileMenu = useSelector(state => state.common.profileMenu);
  const menuItems = useSelector(state => state.common.menuItems);
  const user = useSelector(state => state.login.user);
  const messaging = useSelector(state => state.common.messaging);
  const newUIFlag = useSelector(state => state.common.newUIFlag);
  const clientSettings = useSelector(state => state.common.clientSettings);
  const dashboardActionsData = useSelector(state => state.dashboardPP.dashboardActions);

  const totalNotifications = dashboardActionsData
    ? dashboardActionsData.totalNotificationsAction
    : 0;

  const dispatch = useDispatch();

  useEffect(() => {
    if (clientSettings.newUIFlag) {
      // Define the message handler
      const messageHandler = event => {
        if (event.data === "HDF_SAVE_SUCCESS") {
          dispatch(getDashboardActions());
        }
      };

      // Add the message handler
      window.addEventListener("message", messageHandler);

      // Remove the message handler when the component unmounts
      return () => {
        window.removeEventListener("message", messageHandler);
      };
    }
  }, []);

  const isHrAdmin = user && user.hrAdmin;
  const isImpersonateUser = isHrAdmin && user.employee;
  const administeredEmployee = isHrAdmin && user.employee ? user.employee.fullName : null;

  const benefitCheckout = "FlexBenefitsMain_CheckOut";
  const insuranceCheckout = "FlexBenefitsMain_InsuranceCheckOut";

  const insurancePath = getCartPath(menuItems, insuranceCheckout);
  const benefitPath = getCartPath(menuItems, benefitCheckout);
  const isMobile = isMobileBrowser();
  const dropdownToggle = (event, isOpen) => {
    if (isOpen === undefined) {
      isOpen = !isDropdownOpen;
    }

    setIsDropdownOpen(isOpen);
  };

  return (
    <NavBar
      cartPath={insurancePath || benefitPath}
      isDropdownOpen={isDropdownOpen}
      dropdownToggle={dropdownToggle}
      displayedName={getDisplayedName(user)}
      newShopUrl={getNewShopUrl(menuItems)}
      messaging={messaging}
      newUIFlag={newUIFlag}
    >
      <DropdownItem
        enabled={
          isEnabled(DropdownTypes.EMPLOYEE_PROFILE, profileMenu) &&
          (!isHrAdmin || administeredEmployee)
        }
        type={DropdownTypes.EMPLOYEE_PROFILE}
        to="/userProfile"
        profileMenu={profileMenu}
        messaging={messaging}
        onClick={evt => dropdownToggle(evt, false)}
      />
      <DropdownItem
        enabled={
          isEnabled(DropdownTypes.MESSAGES, profileMenu) && messaging.menu.isMessagingEnabled
        }
        type={DropdownTypes.MESSAGES}
        to="/messages"
        profileMenu={profileMenu}
        messaging={messaging}
        onClick={evt => dropdownToggle(evt, false)}
      />
      {!isImpersonateUser && clientSettings.newUIFlag && (
        <DropdownItem
          enabled={
            isEnabled(DropdownTypes.PUSH_NOTIFICATIONS, profileMenu) &&
            messaging.menu.isPushNotificationEnabled
          }
          type={DropdownTypes.PUSH_NOTIFICATIONS}
          to="/notifications"
          profileMenu={profileMenu}
          messaging={messaging}
          totalNotifications={totalNotifications}
          onClick={evt => dropdownToggle(evt, false)}
        />
      )}
      {!isImpersonateUser && (
        <DropdownItem
          enabled={isEnabled(DropdownTypes.CHANGE_PASSWORD, profileMenu)}
          type={DropdownTypes.CHANGE_PASSWORD}
          to="/changePassword"
          profileMenu={profileMenu}
          messaging={messaging}
          onClick={evt => dropdownToggle(evt, false)}
        />
      )}
      <DropdownItem
        enabled={isEnabled(DropdownTypes.DELEGATION, profileMenu)}
        type={DropdownTypes.DELEGATION}
        to="/delegation"
        profileMenu={profileMenu}
        messaging={messaging}
        onClick={evt => dropdownToggle(evt, false)}
      />
      {!isMobile && !isImpersonateUser && Array.isArray(user.roles) && user.roles.length > 1 && (
        <li>
          <button
            style={{ padding: "0.25em 0.5em", margin: "auto 0.25em" }}
            className="link"
            onClick={() => dispatch(switchRole())}
          >
            {props.intl.formatMessage(messages.roleSelection.switchRoleDescription)}
          </button>
        </li>
      )}
      {!isImpersonateUser && (
        <DropdownItem
          enabled={isEnabled(DropdownTypes.LOG_OUT, profileMenu)}
          type={DropdownTypes.LOG_OUT}
          to="/logout"
          profileMenu={profileMenu}
          messaging={messaging}
        />
      )}
    </NavBar>
  );
}

NavMenuProfile.propTypes = {
  intl: PropTypes.object,
  profileMenu: PropTypes.object,
  menuItems: PropTypes.array,
  user: PropTypes.object,
  push: PropTypes.func,
  clearHRSelectedEmployee: PropTypes.func,
  messaging: PropTypes.object,
  newUIFlag: PropTypes.bool,
};

export default injectIntl(NavMenuProfile);



// WEBPACK FOOTER //
// ./components/common/navigation/NavMenuProfile.js